import { FolderOpen, FileCheck2, CalendarCheck, Loader, CheckCircle2 } from "lucide-react";
import { t, getLocale } from "@/lib/i18n";

const st = (key, Icon) => ({ key, Icon, get label() { return t(`st.${key}`); }, get next() { return t(`st.${key}.n`); } });

export const STATUSES = [
  st("abierto", FolderOpen),
  st("documentos", FileCheck2),
  st("cita", CalendarCheck),
  st("proceso", Loader),
  st("resuelto", CheckCircle2),
];

export const statusInfo = (key) => STATUSES.find((s) => s.key === key) || STATUSES[0];

export const extractDependency = (answer = "") => {
  const m = answer.split(/##\s*4\.[^\n]*\n/)[1];
  return m ? m.split("\n").find((l) => l.trim())?.replace(/\*\*/g, "").replace(/^[-•]\s*/, "").slice(0, 160) : "";
};

export const formatAppt = (iso) => {
  const t0 = new Date(iso).toLocaleString(getLocale(), { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  return t0.charAt(0).toUpperCase() + t0.slice(1);
};

export const caseWhatsAppUrl = (c, kind = "update") => {
  const s = statusInfo(c.status);
  const dep = extractDependency(c.answer);
  const lines =
    kind === "created"
      ? [
          `*${t("wac.created")}* ✅`,
          ``,
          `*${t("wac.folio")}:* ${c.folio}`,
          `*${t("wac.case")}:* ${c.title}`,
          dep ? `*${t("wac.dep")}:* ${dep}` : null,
          `*${t("wac.status")}:* ${s.label}`,
          `*${t("wac.next")}:* ${s.next}`,
          ``,
          `_${t("wac.keep")}_`,
        ]
      : [
          `*${t("wac.update")}* 🔔`,
          ``,
          `*${t("wac.folio")}:* ${c.folio}`,
          `*${t("wac.case")}:* ${c.title}`,
          `*${t("wac.newStatus")}:* ${s.label}`,
          c.appointment ? `*${t("wac.appt")}:* ${formatAppt(c.appointment.at)}${c.appointment.place ? ` ${t("wac.at")} ${c.appointment.place}` : ""}` : null,
          `*${t("wac.next")}:* ${s.next}`,
        ];
  const text = lines.filter((l) => l !== null).join("\n");
  return `https://wa.me/52${c.phone}?text=${encodeURIComponent(text)}`;
};
